import React from "react";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";
import { BRAND } from "@/lib/brand";
import { Reveal } from "@/components/Motion";

export const FinalCta = () => (
  <section className="grain relative overflow-hidden border-b border-white/8">
    <div className="absolute inset-0">
      <img src={BRAND.banner} alt="" className="h-full w-full object-cover opacity-45" />
    </div>
    <div className="absolute inset-0 bg-gradient-to-b from-[#08080a]/85 via-[#08080a]/70 to-[#08080a]" />
    <div className="hairline-grid absolute inset-0 opacity-40" />

    <div className="relative mx-auto max-w-[1400px] px-5 py-28 sm:px-8 lg:py-40">
      <Reveal>
        <div className="label">Ready when you are</div>
        <h2 className="mt-7 max-w-4xl font-display text-[clamp(2.2rem,6vw,5rem)] font-extrabold uppercase leading-[0.94] tracking-[-0.02em] text-white">
          Give your server the details people actually clip.
        </h2>
        <div className="mt-11 flex flex-wrap items-center gap-4">
          <a
            href="#store"
            data-testid="final-store-button"
            className="group relative overflow-hidden bg-white px-9 py-4 font-mono text-[11px] uppercase tracking-[0.22em] text-black"
          >
            <span className="relative z-10 flex items-center gap-3">
              Shop the store
              <ArrowDownRight className="h-4 w-4 transition-transform duration-400 group-hover:translate-x-1 group-hover:translate-y-1" />
            </span>
            <span className="absolute inset-0 z-0 -translate-y-full bg-[hsl(var(--orv-blue))] transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:translate-y-0" />
          </a>
          <a
            href={BRAND.discord}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="discord-community-link"
            className="group flex items-center gap-3 border border-white/18 px-8 py-4 font-mono text-[11px] uppercase tracking-[0.2em] text-white/75 transition-colors duration-300 hover:border-white/50 hover:text-white"
          >
            Join the Discord
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
